/**
 * Per-turn capability overrides a voice-mode turn carries (client/src/lib/
 * useVoiceMode.js's consumePendingPatch): {retrievalEnabled, toolsEnabled}.
 * Both chat senders (useAgentChat.js internal, useEmbedChat.js embed) spread
 * this into their request body so the flags reach chatEngine.submitTurn's
 * app_agent_chat_jobs row exactly the same way on both surfaces. Pure and
 * exported for unit tests — this file has no React (jsdom+vitest only here,
 * no @testing-library, so hooks themselves can't be rendered in tests).
 *
 * @param {{retrievalEnabled?: boolean, toolsEnabled?: boolean} | undefined} turnOpts
 * @returns {object} fields to spread into the send body; only keys that are
 *   actually set appear (null/undefined toggles stay out — server treats
 *   absent as "no override", never as false).
 */
export function turnFlagsFor(turnOpts) {
  if (!turnOpts) return {};
  return {
    ...(turnOpts.retrievalEnabled != null ? { retrievalEnabled: turnOpts.retrievalEnabled } : {}),
    ...(turnOpts.toolsEnabled != null ? { toolsEnabled: turnOpts.toolsEnabled } : {}),
  };
}

export default turnFlagsFor;
